<div class="forum-item" (click)="onClick(forum.id)">
  <img [src]="getImageURL(forum.iconImage.path)" class="forum-icon" />
  <h4>{{ forum.name }}</h4>
</div>
